import {
  Text,
  Toggle,
} from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

import {
  StyledHelperText,
  StyledToggleBlock,
  StyledToggleContainer,
} from "./styles";

interface ToggleSwitchProps {
  fieldId: string;
}

function ToggleSwitch({ fieldId }: ToggleSwitchProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);
  const value = field.value.asBool();
  const isChecked = value.value() || value.defaultValue();

  const writable = field.writable;

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);
  const helper = field.hasHelper()
    ? translateField(translator, field, Suffix.HELP).toString()
    : "";

  const handleToggleChange = () => {
    field.setValue(!value.value());
  };

  return (
    <StyledToggleContainer>
      <StyledToggleBlock>
        <Toggle
          isActive={Boolean(isChecked)}
          onChange={handleToggleChange}
          disabled={!writable}
          size={"medium"}
          key={field.id()}
          dataTestId={`${dataTestIdPrefix}-${field.id()}`}
        />
        <Text variant='text2'>{label.toString()}</Text>
      </StyledToggleBlock>

      {helper && <StyledHelperText variant='text1'>{helper}</StyledHelperText>}
    </StyledToggleContainer>
  );
}

export default ToggleSwitch;
